import { render, staticRenderFns } from "./RequestConsultationReportModal.vue?vue&type=template&id=ef0de9ae"
import script from "./RequestConsultationReportModal.vue?vue&type=script&lang=js"
export * from "./RequestConsultationReportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports